module.exports = __webpack_public_path__ + "static/media/19_before.d255c244.jpg";